/**
@format
@flow
*/

const calculateElapsedTime = (timeDifference: number): string => {
  const isFuture = timeDifference < 0;
  const labelSuffix = isFuture ? 'left' : 'ago';
  const adjustedTimeDifference = Math.abs(timeDifference);

  const weekDifference = adjustedTimeDifference / (1000 * 3600 * 24 * 7);
  const dayDifference = adjustedTimeDifference / (1000 * 3600 * 24);
  const hourDifference = adjustedTimeDifference / (1000 * 3600);
  const minuteDifference = adjustedTimeDifference / (1000 * 60);
  let timeLabel;

  if (weekDifference >= 1) {
    if (weekDifference < 2) {
      timeLabel = `${Math.floor(weekDifference)} week ${labelSuffix}`;
    } else {
      timeLabel = `${Math.floor(weekDifference)} weeks ${labelSuffix}`;
    }
  } else if (dayDifference >= 1 && dayDifference < 7) {
    if (dayDifference < 2) {
      timeLabel = `${Math.floor(dayDifference)} day ${labelSuffix}`;
    } else {
      timeLabel = `${Math.floor(dayDifference)} days ${labelSuffix}`;
    }
  } else if (hourDifference >= 1 && hourDifference < 24) {
    if (hourDifference < 2) {
      timeLabel = `${Math.floor(hourDifference)} hour ${labelSuffix}`;
    } else {
      timeLabel = `${Math.floor(hourDifference)} hours ${labelSuffix}`;
    }
  } else if (minuteDifference >= 1 && minuteDifference < 60) {
    timeLabel = `${Math.floor(minuteDifference)} mins ${labelSuffix}`;
  } else {
    timeLabel = `less than a minute ${labelSuffix}`;
  }
  return timeLabel;
};

const formatDate = (rawDate: number): string => {
  const currentTime = new Date();
  const dateCreated = new Date(rawDate);
  const timeDifference = currentTime.getTime() - dateCreated.getTime();

  return calculateElapsedTime(timeDifference);
};

export default formatDate;
